// Action Types
export const SETUP_COUNTER = 'ticketsScanner/checkedIn/SETUP_COUNTER'
export const UPDATE_CHECKED_COUNT = 'ticketsScanner/checkedIn/UPDATE_CHECKED_COUNT'
export const SET_SUBSCRIPTION = 'ticketsScanner/checkedIn/SET_SUBSCRIPTION'

// Initial State
const initialState = {
  counter: {
    checked: null,
    total: null,
  },
  subscription: null,
}

// Reducer
export default function checkedInReducer(state = initialState, action) {
  switch (action.type) {
    case SETUP_COUNTER:
      return {
        ...state,
        counter: action.payload,
      }

    case UPDATE_CHECKED_COUNT:
      if (action.payload.checked_in_count !== undefined) {
        return {
          ...state,
          counter: {
            ...state.counter,
            checked: action.payload.checked_in_count,
          },
        }
      }
      return state

    case SET_SUBSCRIPTION:
      return {
        ...state,
        subscription: action.payload,
      }

    default:
      return state
  }
}

// Action Creators
export const setupCounter = (checked, total) => ({
  type: SETUP_COUNTER,
  payload: { checked, total },
})

export const updateCheckedCount = (data) => ({
  type: UPDATE_CHECKED_COUNT,
  payload: data,
})

const setSubscription = (subscription) => ({
  type: SET_SUBSCRIPTION,
  payload: subscription,
})

// Thunk for setting up ActionCable subscription
export const setupActionCableSubscription = () => (dispatch) => {
  if (typeof ActionCable !== 'undefined') {
    const subscription = ActionCable.createConsumer().subscriptions.create(
      { channel: 'TicketCheckedInCountChannel' },
      {
        received: (data) => {
          dispatch(updateCheckedCount(data))
        },
      }
    )
    dispatch(setSubscription(subscription))
  }
}

// Selectors
export const selectCounter = (state) => 
  state.ticketsScanner?.checkedIn?.counter || { checked: null, total: null }
export const selectCheckedCount = (state) => 
  state.ticketsScanner?.checkedIn?.counter?.checked
export const selectTotalCount = (state) => 
  state.ticketsScanner?.checkedIn?.counter?.total
